function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  d: "M-72-48v96H72v-96z"
});

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  stroke: "#000",
  strokeWidth: 4
}, React.createElement("path", {
  transform: "rotate(33.69006752598)",
  d: "M-50-12v24m6 0v-24m6 0v24m76 0V1m0-2v-11m6 0v11m0 2v11m6 0V1m0-2v-11"
}), React.createElement("path", {
  transform: "rotate(-33.69006752598)",
  d: "M-50-12v24m6 0V1m0-2v-11m6 0v24m76 0V1m0-2v-11m6 0v24m6 0V1m0-2v-11"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  transform: "rotate(33.69006752598)"
}, React.createElement("path", {
  fill: "#cd2e3a",
  d: "M12 0a18 18 0 11-36 0 24 24 0 1148 0"
}), React.createElement("path", {
  fill: "#0047a0",
  d: "M0 0a12 12 0 1124 0 24 24 0 11-48 0 12 12 0 1024 0"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 900,
    height: 600,
    viewBox: "-72 -48 144 96"
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/korea.95ee411e.svg";
export { SvgComponent as ReactComponent };